const _excluded = ["children", "className", "dismissOnClick", "theme"],
  _excluded2 = ["placement", "trigger", "label", "inline", "floatingArrow", "arrowIcon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children, useCallback, useEffect, useId, useMemo, useRef, useState } from 'react';
import { HiOutlineChevronDown, HiOutlineChevronLeft, HiOutlineChevronRight, HiOutlineChevronUp } from 'react-icons/hi';
import { Button, useTheme } from '../../';
import { Floating } from '../../components/Floating';
import { mergeDeep } from '../../helpers/merge-deep';
import { DropdownDivider } from './DropdownDivider';
import { DropdownHeader } from './DropdownHeader';
import { DropdownItem } from './DropdownItem';
const icons = {
  top: HiOutlineChevronUp,
  right: HiOutlineChevronRight,
  bottom: HiOutlineChevronDown,
  left: HiOutlineChevronLeft
};
const DropdownComponent = _ref => {
  let children = _ref.children,
    className = _ref.className,
    _ref$dismissOnClick = _ref.dismissOnClick,
    dismissOnClick = _ref$dismissOnClick === void 0 ? true : _ref$dismissOnClick,
    _ref$theme = _ref.theme,
    customTheme = _ref$theme === void 0 ? {} : _ref$theme,
    props = _objectWithoutProperties(_ref, _excluded);
  const id = useId();
  const theme = mergeDeep(useTheme().theme.dropdown, customTheme);
  const theirProps = props;
  const _theirProps$placement = theirProps.placement,
    placement = _theirProps$placement === void 0 ? props.inline ? 'bottom-start' : 'bottom' : _theirProps$placement,
    _theirProps$trigger = theirProps.trigger,
    trigger = _theirProps$trigger === void 0 ? 'click' : _theirProps$trigger,
    label = theirProps.label,
    inline = theirProps.inline,
    _theirProps$floatingA = theirProps.floatingArrow,
    floatingArrow = _theirProps$floatingA === void 0 ? false : _theirProps$floatingA,
    _theirProps$arrowIcon = theirProps.arrowIcon,
    arrowIcon = _theirProps$arrowIcon === void 0 ? true : _theirProps$arrowIcon,
    buttonProps = _objectWithoutProperties(theirProps, _excluded2);
  const Icon = useMemo(() => {
    var _icons$p;
    const _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 1),
      p = _placement$split2[0];
    return (_icons$p = icons[p]) !== null && _icons$p !== void 0 ? _icons$p : HiOutlineChevronDown;
  }, [placement]);
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    closeRequestKey = _useState2[0],
    setCloseRequestKey = _useState2[1];
  const _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    buttonWidth = _useState4[0],
    setButtonWidth = _useState4[1];
  // Extends DropdownItem's onClick to trigger a close request to the Floating component
  const attachCloseListener = useCallback(
  // @ts-ignore TODO: Rewrite Dropdown
  node => {
    if (! /*#__PURE__*/React.isValidElement(node)) return node;
    if (node.type === DropdownItem) return /*#__PURE__*/React.cloneElement(node, {
      // @ts-ignore TODO: Rewrite Dropdown
      onClick: () => {
        var _node$props$onClick, _node$props;
        (_node$props$onClick = (_node$props = node.props).onClick) === null || _node$props$onClick === void 0 ? void 0 : _node$props$onClick.call(_node$props);
        dismissOnClick && setCloseRequestKey(id);
      }
    });
    if (node.props.children && typeof node.props.children === 'object') {
      return /*#__PURE__*/React.cloneElement(node, {
        // @ts-ignore TODO: Rewrite Dropdown
        children: Children.map(node.props.children, attachCloseListener)
      });
    }
    return node;
  }, [dismissOnClick, id]);
  const content = useMemo(() => _jsx("ul", {
    className: theme.content,
    children: Children.map(children, attachCloseListener)
  }), [attachCloseListener, children, theme.content]);
  const TriggerWrapper = _ref2 => {
    let children = _ref2.children,
      setButtonWidth = _ref2.setButtonWidth;
    const ref = useRef(null);
    useEffect(() => {
      if (ref.current) setButtonWidth === null || setButtonWidth === void 0 ? void 0 : setButtonWidth(ref.current.clientWidth);
    }, [ref]);
    return inline ? _jsx("button", {
      type: "button",
      ref: ref,
      className: theme.inlineWrapper,
      children: children
    }) : _jsx(Button, _objectSpread(_objectSpread({
      type: "button",
      ref: ref
    }, buttonProps), {}, {
      children: children
    }));
  };
  return _jsx(Floating, {
    content: content,
    style: "auto",
    animation: "duration-100",
    placement: placement,
    arrow: floatingArrow,
    trigger: trigger,
    theme: theme.floating,
    closeRequestKey: closeRequestKey,
    className: className,
    minWidth: buttonWidth,
    children: _jsxs(TriggerWrapper, {
      setButtonWidth: setButtonWidth,
      children: [label, arrowIcon && _jsx(Icon, {
        className: theme.arrowIcon
      })]
    })
  });
};
DropdownComponent.displayName = 'Dropdown';
DropdownItem.displayName = 'Dropdown.Item';
DropdownHeader.displayName = 'Dropdown.Header';
DropdownDivider.displayName = 'Dropdown.Divider';
export const Dropdown = Object.assign(DropdownComponent, {
  Item: DropdownItem,
  Header: DropdownHeader,
  Divider: DropdownDivider
});